import React from 'react';
import { PopUp } from '../PopUp';
import { Guess } from '../../Guess/Guess';

interface EndModalProps {
  randomized: boolean;
  code: string[];
  guesses: string[][];
  scores: string[][];
  playAgainCallback: () => void;
  closeCallback: () => void;
}

interface EndModalState {
  copied: boolean;
}

export class EndModal extends React.Component<EndModalProps, EndModalState> {

  constructor(props: EndModalProps){
    super(props);
    this.state = {copied: false}
  }
  
  validateWin(): boolean{
    const {code, guesses} = this.props;
    return this.areEqual(guesses[guesses.length-1], code);
  }

  areEqual(guess: string[], code: string[]){
    return guess.every( (value, index) => value === code[index]);
  }
  
  scoreStringGenerator(scores: string[][]): string{
    const colorMap: Map<string,string> = new Map();
    colorMap.set('Green', '🟩')
    colorMap.set('Yellow', '🟨')
    colorMap.set('Red', '🟥')

    let scoreString: string = '';
      scores.forEach(score =>{
        score.forEach(color => scoreString += colorMap.get(color));
        scoreString += '\n';
      }
    );
    
    return scoreString;
  }

  codeStringGenerator(code: string[]): string{
    const colorMap: Map<string,string> = new Map();
    colorMap.set('Green', '🟩')
    colorMap.set('Yellow', '🟨')
    colorMap.set('Red', '🟥')
    colorMap.set('Black', '⬛')
    colorMap.set('White', '⬜')
    colorMap.set('Blue', '🟦')

    let finalString: string = '';
    code.forEach(color => finalString = finalString.concat(colorMap.get(color) ?? `Color not found ${color}`));
    return finalString;
  }

  didWin(): boolean{
    return this.props.scores[this.props.scores.length-1].every(value => value === 'Green');
  }

  showCopied(): void{
    this.setState({copied: true});
    setTimeout(() => {
      this.setState({copied: false});
    },
    3000)
  }

  render(): React.ReactNode {
    return(
      <PopUp closeCallback={() => this.props.closeCallback()}>
        <h2 className='mb-4 text-6xl'> { this.validateWin() ? 'You Won' : 'You Lost'} </h2>
        <p className='mb-4 font-extrabold text-1xl'> Final Code Was: </p>
        <Guess guess={this.props.code} score={[]}></Guess>
        <div className='my-4'></div>
        <button 
          className='w-2/3 bg-buttonsBackground h-[10%] mb-3 hover:scale-110 active:scale-90' 
          onClick={() => {
            this.props.playAgainCallback();
          }}
          > 
            Play {this.props.randomized ? 'Another Random Game' : 'A Random Game'} 
          </button>
        { !this.props.randomized && 
        <button 
          className='w-2/3 bg-buttonsBackground h-[10%] hover:scale-110 active:scale-90 disabled:scale-100' 
          onClick={() => {
            navigator.clipboard.writeText(`I ${this.didWin() ? 'won ' : 'lost '}todays codecrackr${this.didWin() ? ` in ${this.props.scores.length} guesse${this.props.scores.length > 1 ? 's' : ''}` : ''}!\n${this.scoreStringGenerator(this.props.scores)} Play at jacobharmon43.github.io/#/Codecrackr`);
            this.showCopied();
          }}
          disabled={this.state.copied}
          > 
            {this.state.copied ? 'Copied to Clipboard' : 'Share your score' } 
          </button> }
      </PopUp>
    );
  }
}
